export const encode = (str: string): string => {
  if (typeof Buffer !== 'undefined') {
    return Buffer.from(str, 'utf-8').toString('base64')
  }
  if (typeof btoa !== 'undefined') {
    // For browser, handle UTF-8 by first encoding to percent-escaped string,
    // then converting to a string where each character represents one byte of UTF-8
    return btoa(encodeURIComponent(str).replace(/%([0-9A-F]{2})/g, (_, p1) => String.fromCharCode(parseInt(p1, 16))))
  }
  throw new Error('No base64 encoding implementation found')
}

export const decode = (str: string): string => {
  if (typeof Buffer !== 'undefined') {
    return Buffer.from(str, 'base64').toString('utf-8')
  }
  if (typeof atob !== 'undefined') {
    // For browser, decode base64 to byte-string,
    // then convert back from percent-encoded UTF-8
    return decodeURIComponent(
      Array.prototype.map
        .call(atob(str), (c: string) => `%${(`00${c.charCodeAt(0).toString(16)}`).slice(-2)}`)
        .join(''),
    )
  }
  throw new Error('No base64 decoding implementation found')
}
